import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteEventSlice = createSlice({
    name: "deleteEvent",
    initialState,
    reducers: {
        deleteEventRequest(state) {
            state.loading = true;
        },
        deleteEventRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteEventRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteEventStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteEventRequest,
    deleteEventRequestSuccess,
    deleteEventRequestError,
    deleteEventStateReset,
} = DeleteEventSlice.actions;

export default DeleteEventSlice.reducer;
